import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/sys/app',
  owner: '/home',
  authority: 'app',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};